import httpService from "../../components/service";

export const versioning = {
    namespaced: true,
    state: {
        versionings: [],
        versioning: null,
        edit: false,
        versioningsUpcoming: [],
        versioningsCurrent: []
    },
    getters: {
        getVersionings(state) {
            return state.versionings;
        },
        getVersioningsUpcoming(state) {
            return state.versioningsUpcoming;
        },
        getVersioningsCurrent(state) {
            return state.versioningsCurrent;
        },
        getVersioning(state) {
            return state.versioning;
        },
        canEdit(state) {
            return state.edit;
        }
    },
    mutations: {
        FIND_ALL_VERSIONING(state, versionings) {
            state.versionings = versionings;
        },
        FIND_ALL_VERSIONING_UPCOMING(state, versionings) {
            state.versioningsUpcoming = versionings;
        },
        FIND_ALL_VERSIONING_CURRENT(state, versionings) {
            state.versioningsCurrent = versionings;
        },
        FIND_VERSIONING_BY_ID(state, versioning) {
            state.versioning = versioning;
            state.edit = true;
        },
        NEW_VERSIONING(state) {
            state.versioning = null;
            state.edit = true;
        },
        SET_EDIT(state, edit) {
            state.edit = edit;
        }
    },
    actions: {
        findAllVersionings(context) {
            return httpService.get("/admin/versioning").then(res => {
                context.commit("FIND_ALL_VERSIONING", res);
                let versioningsUpcomming = res.filter(version => {
                    return version.upcoming === true;
                });

                let versioningsCurrent = res.filter(version => {
                    return !version.upcoming;
                });

                context.commit("FIND_ALL_VERSIONING_UPCOMING", versioningsUpcomming);
                context.commit("FIND_ALL_VERSIONING_CURRENT", versioningsCurrent);

                return res;
            });
        },
        findVersioningById(context, id) {
            httpService.get("/admin/versioning/" + id).then(res => {
                context.commit("FIND_VERSIONING_BY_ID", res[0]);
                return res;
            });
        },
        newVersioning(context) {
            return new Promise(resolve => {
                context.commit("NEW_VERSIONING");
                resolve(true);
            });
        },
        saveVersioning(context, versioning) {
            if (!versioning.id) {
                httpService.post("/admin/versioning", JSON.stringify(versioning)).then(res => {
                    context.commit("FIND_ALL_VERSIONING", res);
                    return res;
                });
            } else {
                httpService.put("/admin/versioning/" + versioning.id, JSON.stringify(versioning)).then(res => {
                    return context.dispatch("findAllVersionings");
                });
            }
        },
        setEdit(context, edit) {
            context.commit("SET_EDIT", edit);
        },
        deleteVersioning(context, versioning) {
            httpService.delete("/admin/versioning/" + versioning.id).then(res => {
                return context.dispatch("findAllVersionings");
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/versioning/versioning.js